import { defineMessages } from "react-intl";

import TourDescriptor from "@app/component/flows/types/TourDescriptor";
import ensureSettingsCategoryOpen from "@app/component/flows/utils/ensureSettingsCategoryOpen";

const messages = defineMessages({
  step01: {
    id: "guides.resources.sharingPermissionsTour.step01",
    defaultMessage: "Sharing Permissions",
  },
  step01Description: {
    id: "guides.resources.sharingPermissionsTour.step01.description",
    defaultMessage:
      "Admins control who can upload, view, and share resources. To manage Sharing Permissions, navigate to Settings page.",
  },
  step02: {
    id: "guides.resources.sharingPermissionsTour.step02",
    defaultMessage: "Sharing Permissions",
  },
  step02Description: {
    id: "guides.resources.sharingPermissionsTour.step02.description",
    defaultMessage: "Navigate to Organization Preferences.",
  },
  step03: {
    id: "guides.resources.sharingPermissionsTour.step03",
    defaultMessage: "Sharing Permissions",
  },
  step03Description: {
    id: "guides.resources.sharingPermissionsTour.step03.description",
    defaultMessage: "Select Resources tab.",
  },
  step04: {
    id: "guides.resources.sharingPermissionsTour.step04",
    defaultMessage: "Sharing Permissions",
  },
  step04Description: {
    id: "guides.resources.sharingPermissionsTour.step04.description",
    defaultMessage: "Configure sharing permissions for Managers and Team Members.",
  },
});

export const sharingPermissionsTourConfiguration: TourDescriptor = {
  id: "mmc-resources-sharing-permissions",
  steps: [
    {
      id: "intro",
      description: messages.step01Description,
      goToPathAfter: "/settings",
      selector: "[data-navbar-item='/settings']",
      title: messages.step01,
    },
    {
      id: "org-settings",
      description: messages.step02Description,
      goToPathAfter: "/settings/organization/details",
      onBefore: async () => {
        await ensureSettingsCategoryOpen("organization");
      },
      position: "right",
      selector: "[data-menu-item=org-details]",
      title: messages.step02,
    },
    {
      id: "resources-tab-1",
      description: messages.step03Description,
      goToPathAfter: "/settings/organization/details/resources",
      position: "bottom",
      selector: "[data-node-key=resources]",
      title: messages.step03,
    },
    {
      id: "resources-tab-2",
      description: messages.step04Description,
      position: "bottom",
      selector: "[class*=Resources_container]",
      title: messages.step04,
    },
  ],
};
